import React from "react";

import ButtonLoader from "../ButtonLoader";

/**
 * Renders an authentication button component.
 *
 * @param {object} props - An object containing the props for the component.
 * @return {JSX.Element} The rendered authentication button component.
 */
const AuthButton = (props) => {
  const {
    submitForm,
    isSubmitting,
    isValid,
    btnText,
    btnLoadingText,
    disabled = false,
  } = props;
  return (
    <div className="mt-6">
      <button
        type="button"
        onClick={() => {
          if (isSubmitting) return;
          submitForm();
        }}
        className="relative h-[40px] w-full rounded-lg bg-primary !text-[16px] !text-white transition hover:bg-primaryHover focus:outline-none active:bg-primaryActive"
        // disabled={!isValid}
        disabled={disabled}
      >
        {isSubmitting ? (
          <ButtonLoader text={btnLoadingText} loadingFirst />
        ) : (
          <span>{btnText}</span>
        )}
      </button>
    </div>
  );
};

export default AuthButton;
